/* eslint-disable no-nested-ternary */
import { FormattedMessage } from "react-intl";
import { IIndicatorKind } from "types/graphqlTypes";

interface ChangeTextProps {
  kind?: IIndicatorKind;
  variation: number;
}
export default function ChangeText({ kind, variation }: ChangeTextProps) {
  if (kind === IIndicatorKind.Currency || kind === IIndicatorKind.Financial) {
    return (
      <p className="text-xs font-medium text-gray-500 dark:text-slate-400">
        {variation > 0 ? (
          <FormattedMessage
            defaultMessage="Ganho"
            id="X9kEcO"
            description="Lucro/prejuízo em $ da popup da tabela de balanços"
          />
        ) : variation === 0 ? (
          <FormattedMessage
            defaultMessage="Sem mudança"
            id="QZp/tr"
            description="Lucro/prejuízo em $ da popup da tabela de balanços"
          />
        ) : (
          <FormattedMessage
            defaultMessage="Prejuízo"
            id="ASzeXl"
            description="Lucro/prejuízo em $ da popup da tabela de balanços"
          />
        )}
      </p>
    );
  }
  return (
    <p className="text-xs font-medium text-gray-500 dark:text-slate-400">
      {variation > 0 ? (
        <FormattedMessage
          defaultMessage="Ganho"
          id="X9kEcO"
          description="Lucro/prejuízo em $ da popup da tabela de balanços"
        />
      ) : variation === 0 ? (
        <FormattedMessage
          defaultMessage="Sem mudança"
          id="QZp/tr"
          description="Lucro/prejuízo em $ da popup da tabela de balanços"
        />
      ) : (
        <FormattedMessage
          defaultMessage="Queda"
          id="YV1IQB"
          description="Lucro/prejuízo em $ da popup da tabela de balanços"
        />
      )}
    </p>
  );
}
